import { lazy, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useSelector } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import PageNotFound from "../Components/PageNotFound";
import ProtectedRoute from "./ProtectedRoute";

const lazyWithReload = (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem("page-has-been-force-refreshed") || "false"
    );
    try {
      const component = await componentImport();
      window.localStorage.setItem("page-has-been-force-refreshed", "false");
      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window.localStorage.setItem("page-has-been-force-refreshed", "true");
        return window.location.reload();
      }
      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      throw error;
    }
  });

const UserListing = lazyWithReload(() => import("../Pages/User/Page"));

const PrivateRoute = () => {
  const ErrorFallback = ({ error }) => {
    return (
      <div role="alert">
        <p>Something went wrong:</p>
        <pre style={{ color: "red" }}>{error.message}</pre>
      </div>
    );
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Suspense fallback={""}>
        <Switch>
          <ProtectedRoute
            exact
            path="/"
            component={UserListing}
            permission={[]}
          />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
};

export default withRouter(PrivateRoute);
